import { requestHandler } from 'lib/api';
import { Dispatch } from 'redux';

import { ActiveMoneyResponse } from './types';

export const getActiveMoney = async (
  dispatch: Dispatch,
  secretId: string,
  query: string,
): Promise<ActiveMoneyResponse | undefined> => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/express/${secretId}/report/activeMoney?${query}`,
    dispatch,
  });
  if (response) return response.data;
};
